// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/folder.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/folder'

import { Icon, type IconComponentProps } from '../icon'

export const FolderIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
